import { Crosshair } from "lucide-react";

export default function Marquee({ items, className = "" }) {
  const Row = ({ id }) => (
    <div className="flex shrink-0 items-center" aria-hidden={id === "b"}>
      {items.map((item, i) => (
        <span key={`${id}-${i}`} className="flex items-center">
          <span className="mx-8 whitespace-nowrap font-display text-lg font-bold uppercase tracking-wide text-bone/50 sm:text-2xl">
            {item}
          </span>
          <Crosshair className="h-4 w-4 shrink-0 text-thermal/70" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y border-thermal/15 bg-field/60 py-5 ${className}`}
    >
      <div className="marquee-track flex w-max">
        <Row id="a" />
        <Row id="b" />
      </div>
    </div>
  );
}
